import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { ChargeItemScreen } from 'screens/charge-item';

export default withPermissions(ChargeItemScreen, [
  GroupSecurity.ChargeItemRead,
]);
